import { Button, Modal, type ModalProps } from 'flowbite-react';
import { useState } from 'react';

import { DataPrivacyModal } from '../dataPrivacy/dataPrivacyModal.component';
import { TermsAndConditionsModal } from '../termsAndConditions/termsAndConditionsModal.component';

export interface AboutModalProps extends ModalProps {}

export const AboutModal = ({
    show,
    onClose
}: AboutModalProps) => {
    const [showTac, setShowTac] = useState(false);
    const [showPrivacy, setShowPrivacy] = useState(false);

    return (
        <>
            <Modal show={show} size="lg" onClose={onClose} popup>
                <Modal.Header />
                <Modal.Body>
                    <h2 className="text-base md:text-xl font-medium text-center text-gray-800 dark:text-gray-400 mb-6">
                        <span>O aplikaci</span>
                    </h2>

                    <div className='flex flex-col items-center gap-2 text-center text-sm mb-6'>
                        <p>Pro Českou republiku aplikaci provozuje společnost:</p>
                        <p><strong>EWMITS s.r.o.</strong> se sídlem Jeronýmova 1750/21, 370 01 České Budějovice, Česká republika, IČ: 22395342, spis. zn. C34906 vedená u Krajského soudu v Českých Budějovicích.</p>
                    </div>

                    <div className='flex flex-col items-center gap-1 text-center text-sm mb-6'>
                        <a href='mailto:info@aikorektury.cz' className='hyperlink'>info@aikorektury.cz</a>
                        <a href='https://www.aikorektury.cz/' target='_blank' rel='noreferrer' className='hyperlink'>www.aikorektury.cz</a>
                        <button type="button" className='hyperlink' onClick={() => setShowTac(true)}>Obchodní podmínky</button>
                        <button type="button" className='hyperlink' onClick={() => setShowPrivacy(true)}>Ochrana osobních údajů</button>
                    </div>


                    <p className='text-center text-sm text-gray-500 mb-6'>
                    Sestavení: {import.meta.env.VITE_APP_VERSION}
                    </p>

                    <div className='flex flex-row items-center justify-center gap-2'>
                        <Button
                            color='primary'
                            onClick={onClose}
                        >Zavřít</Button>
                    </div>
                </Modal.Body>
            </Modal>
            <TermsAndConditionsModal show={showTac} onClose={() => setShowTac(false)} />
            <DataPrivacyModal show={showPrivacy} onClose={() => setShowPrivacy(false)} />
        </>
    );
};
